import {Avatar} from 'antd'
import {organization_Edit_Api} from 'apis'
import {getId} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import createEditableForm from 'views/AppLocals/factory/createEditableForm'
import {yupShape,} from 'views/AppLocals/factory/createValidationSchema'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from 'views/AppLocals/Organization/OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {renderIf, renderIfElse} from "../../../Shared";
import LookupField from "../../../../components/LookupField";
import {MdChurch} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";
import {AssociationStatus, OrgType2Association} from "../consts/AssociationStatus";
import {getType} from "../../../../apis/model/base";
import {ItemInformation} from 'components/common/ItemInformation'
import {GenderTypes} from "../../appFieldTypes";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import EmptyHolder from "../../../../components/EmptyHolder";
import {BiUnlink} from "react-icons/bi";
import {BsMagic} from "react-icons/bs";
import {GoDot, GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const formFields = [
    {name: 'association'},
]

const renderOption = (type, o, isLg) => {

    const gender = _.find(GenderTypes, {value: o?.target_gender || o?.parent?.target_gender})?.label

    let _type  = _.get(OrgType2Association, type)?.value
    let option

    switch (_type) {
        case 'parish':
            option = (
                <div className="p-2 flex items-center flex-1 gap-3">
                    {isLg && (
                        <Avatar
                            size={50}
                            src={o.avatar}
                            className="flex flex-center background-200 rounded-lg"
                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                        />
                    )}
                    <div className="flex flex-col flex-1 gap-1">
                        <div className="space-x-1">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o?.fullname}
                            </span>
                            <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                {`( ${o?.diocese_fullname} )`}
                            </span>
                        </div>
                        {renderIf(
                            o?.location_address,
                            <div className="space-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'diocese':
            option = (
                <div className="p-2 flex items-center flex-1 gap-3">
                    {isLg && (
                        <Avatar
                            size={50}
                            src={o.avatar}
                            className="flex flex-center background-200 rounded-lg"
                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                        />
                    )}
                    <div className="flex flex-col flex-1 gap-1">
                        <div className="space-x-1">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o?.fullname}
                            </span>
                        </div>
                        {renderIf(
                            o?.location_address,
                            <div className="space-x-1">
                                <RiMapPinFill size={11} className="text-color-400"/>
                                <span className="text-xs text-color-400 italic leading-snug">
                                    {o?.location_address}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            )
            break
        case 'religious_order':
            option = (
                <Translate>
                    {(t) => (
                        <div className="p-2 flex items-center flex-1 gap-3">
                            {isLg && (
                                <Avatar
                                    size={50}
                                    src={o.avatar}
                                    className="flex flex-center background-200 rounded-lg"
                                    icon={<ReligiousFillSvg size={30} className="text-color-500"/>}
                                />
                            )}
                            <div className="flex flex-col flex-1 gap-1">
                                <div className="space-x-1">
                                    <span className="font-medium text-sm text-primary-600 italic leading-snug">
                                        {`( ${o?.short_name} )`}
                                    </span>
                                    <span className="font-bold text-sm text-color-000 leading-snug">
                                        {` - ${o?.name}`}
                                    </span>
                                </div>
                                {renderIfElse(
                                    !!o?.religious_order_group,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="religious order group"
                                            value={t(o?.religious_order_group || '')}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>,
                                    <div className="flex items-baseline gap-x-1">
                                        <ItemInformation
                                            label="the branch congregation of"
                                            value={o?.parent?.name}
                                            className="text-xs"
                                        />
                                        <span className="font-bold text-xs text-blue-500 italic leading-tight">
                                            {` - ${t(gender)}`}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Translate>

            )
            break
        default:
            option = (
                <Translate>
                    {(t) => (
                        <div className="flex items-center flex-1 gap-3">
                            {isLg && (
                                <Avatar
                                    size={50}
                                    src={o.avatar}
                                    className="flex flex-center background-200 rounded-lg"
                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                />
                            )}
                            <div className="flex flex-col">
                                <span className="font-bold text-sm text-color-000 leading-snug">
                                    {o?.name}
                                </span>
                                <span className="font-medium text-xs text-blue-500 italic leading-snug">
                                    {t(getType(o))}
                                </span>
                            </div>
                        </div>
                    )}
                </Translate>
            )
            break
    }
    return option
}

const formSchema = [
    {
        children: [
            {
                // label: 'parish',
                name: 'association_type_parish',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <LayoutContext.Consumer>
                        {({isLg}) => (
                            <Translate>
                                {(t) => (
                                    <div className="p-4 background shadow-md rounded-xl flex flex-col gap-3">
                                        {/*  Quy định  */}
                                        <div className="flex flex-col gap-3 text-sm tracking-wider">
                                            <div className="font-bold text-lg uppercase">
                                                <GoDotFill size={12} /> {t("regulations")}:
                                            </div>
                                            <div className="ml-4 flex flex-col gap-2">
                                                <div className="text-sm text-gray-800">
                                                    <GoDot size={12} className="mr-1"/>
                                                    {t("The linking of Groups/Organizations to the parish comes with the responsibility of operating the Group/Organization.")}
                                                </div>
                                                <div className="text-sm text-gray-800">
                                                    <GoDot size={12} className="mr-1"/>
                                                    {t("Along with this, the Group/Organization can manage the following functions:")}
                                                </div>
                                                <div className="ml-4 text-gray-500 italic">
                                                    - {t("Catholic Family Register")}
                                                </div>
                                                <div className="ml-4 text-gray-500 italic">
                                                    - {t("Manage information about churches and mass schedules in the parish")}
                                                </div>
                                                <div className="text-sm text-gray-800">
                                                    <GoDot size={12} className="mr-1"/>
                                                    {t("Once the linking is complete, please update the information for the organization. We sincerely appreciate it.")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="my-1 border-b border-color-100"/>
                                        <div className="flex flex-col gap-3">
                                            <div className="flex flex-col md:flex-row md:items-center gap-3">
                                                <div className="flex flex-col flex-1">
                                                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                                                        {t('connect to organization')}
                                                    </h2>
                                                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                                                    <div className="text-color-300 tracking-wider">
                                                        {t('organization_link_description')}
                                                    </div>
                                                </div>
                                                {renderIf(
                                                    !!form?.values?.association,
                                                    <div className="flex justify-end">
                                                        {renderIf(
                                                            AssociationStatus[form?.values?.association_status],
                                                            <span
                                                                className={classNames(
                                                                    "px-3 py-1 italic rounded-full tracking-wider",
                                                                    AssociationStatus[form?.values?.association_status]?.className
                                                                )}>
                                                    {t(AssociationStatus[form?.values?.association_status]?.label)}
                                                </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <LookupField
                                                title="choose link"
                                                placeholder={t('click to select')}
                                                createIfNotExists={false}
                                                defaultValue={form?.values?.association_name}
                                                selectedOption={form?.values?.association}
                                                apiPath={`/lookup/${_.get(OrgType2Association, form?.values?.org_type)?.value}/get-by-types`}
                                                name={name}
                                                withInput={() => ({ size: "large" })}
                                                OptionWrapper={({children, ...props}) =>
                                                    <div className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                        {children}
                                                    </div>
                                                }
                                                renderOption={(o) => renderOption(form?.values?.org_type, o, isLg)}
                                                handleChange={(e) => {
                                                    form.setValues({...form.values,
                                                        association: e.target,
                                                        association_name: e.target.value,
                                                        association_id: e.target.id,
                                                        association_type: e.target._type});
                                                }}
                                            />
                                        </div>
                                        {/*  Hướng dẫn  */}
                                        <div className="mt-2 p-3 bg-blue-50 border border-blue-400 rounded-xl flex flex-col gap-2 tracking-wider">
                                            <div className="mb-1 font-semibold text-base text-blue-600 tracking-wide underline">
                                                <BsMagic size={16} className="mr-1 text-blue-600"/>
                                                {t('tutorials')}:
                                            </div>
                                            <div className="text-sm text-gray-800">
                                                {t("Please follow the steps below to complete the linking between the organization and the parish.")}
                                            </div>
                                            <div className="text-sm text-gray-500 italic">
                                                {t("1)  Select a parish from the dropdown list below to send a connection request.")}
                                            </div>
                                            <div className="text-sm text-gray-500 italic">
                                                {t("2)  Wait for us to contact you and approve the connection. Please leave your name and contact information in the organization's management section.")}
                                            </div>
                                            <div className="text-sm text-gray-500 italic">
                                                {t("3)  Once the approval is complete, the functions will be unlocked, allowing the administrator to actively publish information about the parish.")}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
]

const OrganizationSettingAssociations = () => {
    const t = useTranslate()

    const {organization} = useContext(OrganizationContainerContext)

    const id = getId(organization)


    const validationSchema = useMemo(
        () =>
            yupShape({}),
        [t]
    )

    const initialized = useCallback(
        ({...values}) => ({
            org_type: organization?.org_type,
            association: organization?.association,
            association_id: organization?.association?.id,
            association_type: getType(organization?.association),
            association_name: organization?.association?.name,
            association_status: organization?.association_status,
            ...values,
        }),
        []
    )

    const onPreSubmit = ({
                             association,
                             ...values
                         }) => {
        return {
            ...values,
        }
    }

    if (_.isEmpty(organization)) return null

    if (!_.get(OrgType2Association, organization.org_type)?.enabled) {
        return (
            <EmptyHolder
                icon={() => <BiUnlink size={80} style={{ color: '#e6e6e6' }}/> }
                className="border border-color-50 rounded-lg my-12 px-8"
                title="link organization"
                subTitle="link organization description"
            />
        )
    }

    return createEditableForm(
        formFields,
        formSchema
    )({
        validationSchema,
        item: {
            ...organization,
        },
        query: bindQueryParam({
            id,
        }),
        onPreSubmit,
        initialized,
        apiInfo: organization_Edit_Api,
    })
}

export default OrganizationSettingAssociations
